import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { message, Spin } from 'antd';

import AnswerList from './answer-list';
import QuestionList from './question-list';
import ProcessInfo from './process-info';
import { previewExamTemp, getExamRecord, getUserInfo } from '../api';
import { QuestionListItem } from '../types';
import { lookStatus, LookStatus } from '../constant';

import './index.less';


const data  = {
  "code": 0,
  "data": {
      "examName": "QACP理论考试",
      "examStartTime": 1642089601,
      "examEndTime": 1673712000,
      "gradeTotal": 99,
      "gradePass": 75,
      "id": 1795,
      "examID": "3BA995CD336541A98E0E698D48D54EB2",
      "userID": "2226",
      "grade": 0,
      "isPass": 0,
      "mark": 1,
      "count": 2,
      "startTime": 1667442784,
      "endTime": 1667446987,
      "question": [
          {
              "title": "单选题",
              "questionType": 1,
              "questions": [
                  {
                      "id": "8d6692a4-750c-11ec-9b61-52549e8e7436",
                      "question": " QingClouD、平台支持多种块存储类型，包括：容量型、性能型、超高性能型、企业级分布式 SAN（NeonSAN）。其中能够有效适用于Oralce RAC应用场景的是哪种类型？",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "D",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6692ab-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "容量型",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6692b1-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "常规性能型",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6692b4-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "企业级分布式SAN（NeonSAN）",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6692a6-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "性能型",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6692e1-750c-11ec-9b61-52549e8e7436",
                      "question": "QingCloud云平台针对不同用户的需求，提供了多维存储的解决方案，请为以下使用场景选择最合 适的存储方案： 一个保险公司，希望建立一个可以保存车险出险照片的存储平台。",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "D",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6692f1-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "对象存储",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6692e3-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "性能型存储",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6692e7-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "Neonsan存储",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6692ea-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "超高性能型存储",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669350-750c-11ec-9b61-52549e8e7436",
                      "question": "在QingCloud云平台部署时，需要配置hyper的存储类型，如果采用Neonsan作为存储架构 ，选择 正确的hyper资源类型 。",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "A",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669356-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "hyper-repl",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669362-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "hyper-pair",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66935a-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "hyper-local",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669352-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "hyper-sanc",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669266-750c-11ec-9b61-52549e8e7436",
                      "question": "QingCloud云平台计算虚拟化基于下列哪种技术实现？",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "B",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669276-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "VMware",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66927b-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "xen",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66926b-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "VirtualBox",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669270-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "kvm",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669380-750c-11ec-9b61-52549e8e7436",
                      "question": "以下哪项是QingCloud云平台SDS1.0虚拟硬盘默认实时副本数。",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "D",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669391-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "2个",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66938b-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "0个",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669387-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "3个",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669382-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "1个",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669427-750c-11ec-9b61-52549e8e7436",
                      "question": " 在管理节点、计算节点、存储节点上都有QingCloud云平台的服务模块运行，QingCloud云平台相 关日志文件通常存放在以下哪目录。",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "A",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669437-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "/var/log/supervisor/",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669429-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "/pitrix/log",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669432-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "/var/log",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66942e-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "/pitrix/conf/global",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669336-750c-11ec-9b61-52549e8e7436",
                      "question": " 以下哪项不是QingCloud云平台的存储架构？",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "C",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669341-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "VSAN",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66933e-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "NEONSAN",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669339-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "SDS 2.0",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669347-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "SDS 1.0",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6692ce-750c-11ec-9b61-52549e8e7436",
                      "question": "服务器RAID配置中，两个span的RAID50最多可以同时坏几块磁盘？",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "A",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6692da-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "1",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6692d3-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "4",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6692cf-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "2",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6692d7-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "3",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6692f8-750c-11ec-9b61-52549e8e7436",
                      "question": "下列哪项属于QingCloud云平台seed节点的作用？",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "D",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6692fd-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "存放删除的虚机文件",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669305-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "存放镜像文件",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6692fa-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "存放备份文件",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669301-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "压缩备份文件",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d66936a-750c-11ec-9b61-52549e8e7436",
                      "question": "QingCloud云平台发送告警邮件发送通过以下哪个服务来实现。",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "C",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669374-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "nf_server",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669378-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "ws_server",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669370-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "fg_server",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66936d-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "compute_server",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d66939b-750c-11ec-9b61-52549e8e7436",
                      "question": "在QingCloud云平台时，物理机操作系统盘 raid推荐的级别是？",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "A",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d66939d-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "raid 1",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6693a5-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "raid 0",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6693aa-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "raid 4",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6693a1-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "raid 5",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669441-750c-11ec-9b61-52549e8e7436",
                      "question": " QingCloud云平台虚拟机监控数据主要保存在以下哪个数据库中。",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "C",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669445-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "redis",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66944b-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "postgres",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669456-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "memchached",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66944f-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "cassandra",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669324-750c-11ec-9b61-52549e8e7436",
                      "question": " 以下关于QingCloud云平台说法正确是？",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "A",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d66932c-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "snapshot节点只能最多两个",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669329-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "QingCloud云平台内存建议超卖",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669330-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "vbr节点可有可无",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669326-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "存储类型为sds1.0的hyper必须成对扩容",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6693e5-750c-11ec-9b61-52549e8e7436",
                      "question": " 以下哪项属于QingCloud云平台vbr节点的作用？",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "A",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6693f3-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "存放QingCloud云平台虚拟机备份文件",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6693e8-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "为QingCloud云平台提供数据备份/恢复引擎",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6693fd-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "存放QingCloud云平台镜像文件",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6693f8-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "存放删除的QingCloud云平台虚拟机文件",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d66930f-750c-11ec-9b61-52549e8e7436",
                      "question": "下列哪个主机名符合QingCloud云平台命名规范。",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "B",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "9cea0bcf-7d8b-11ec-9b61-52549e8e7436",
                              "index": 3,
                              "option": "BJZH1001",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "9cea0bcb-7d8b-11ec-9b61-52549e8e7436",
                              "index": 2,
                              "option": "bjzh0101",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "9cea0bc6-7d8b-11ec-9b61-52549e8e7436",
                              "index": 1,
                              "option": "BJZH1R01N01",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "9cea0bbb-7d8b-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "bjzh1r01n01",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6692ba-750c-11ec-9b61-52549e8e7436",
                      "question": " QingCloud云平台中，如果存储是sds 1.0，以下iCAS缓存和core存储之间的容量配比哪个最优？",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "C",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6692c4-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "1：30 - 1:50",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6692bf-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "1：20 - 1:30",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6692bc-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "1：40 - 1:100",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6692c1-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "1：10 - 1:20",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d66923c-750c-11ec-9b61-52549e8e7436",
                      "question": " 在操作系统中通过那个命令可以使物理网卡eth0指示灯闪烁?",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "C",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669259-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "ethtool eth0",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669242-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "ip link",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669249-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "ethtool -i eth0",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66924f-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "ethtool -p eth0",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669288-750c-11ec-9b61-52549e8e7436",
                      "question": "QingStor NeonSAN支持自定义副本数，副本数量最大是",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "C",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669291-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "1.0",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669296-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "3.0",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66928b-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "2.0",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66929c-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "4.0",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6693b2-750c-11ec-9b61-52549e8e7436",
                      "question": " 如何查看QingCloud云平台软件版本。",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "C",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6693bb-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "NONE登录firstbox，cat /pitrix/version",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6693b7-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "登录firstbox，cat /pitrix/repo/indep/boss/version",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6693b4-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "登录firstbox，cat /pitrix/repo/web/version",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d66940c-750c-11ec-9b61-52549e8e7436",
                      "question": "关于公有云环境中青云VBC与VPC网络，以下说法正确的是？",
                      "title": "单选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "D",
                      "questionType": 1,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d66941d-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "VPC网络为完全隔离的网络环境",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66940f-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "VBC适用大型网络",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669418-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "VBC可提供端口转发",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669413-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "不同的VPC不允许IP地址重叠",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  }
              ]
          },
          {
              "title": "多选题",
              "questionType": 2,
              "questions": [
                  {
                      "id": "8d6694a1-750c-11ec-9b61-52549e8e7436",
                      "question": "下列关于QingCloud云平台组件说法正确的是。",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "CD",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6694c0-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "QingCloud云平台后台数据采用的是mysql plus数据库。",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6694ca-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "QingCloud云平台自有映像模板存放在seed节点上",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6694a5-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "青云console门户的入口是VG服务器。",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6694c5-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "QingCloud云平台自动伸缩服务的是webservice节点实现的",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d66958f-750c-11ec-9b61-52549e8e7436",
                      "question": "在QingCloud云平台部署阶段，以下关于role与磁盘类型对应关系正确的包含哪些。",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "ABC",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669590-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " hyper-pair对应sds1.0",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669599-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " hyper-pair对应sds2.0",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669593-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " hyper-repl对应sds2.0",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66959b-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "hyper-repl对应sds1.0",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669596-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " hyper-sanc对应Qinstor neonsan",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669461-750c-11ec-9b61-52549e8e7436",
                      "question": "下列网络中，哪些属于部署实施QingCloud云平台需要规划的网络？",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "ABCD",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669476-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "VPC网络",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669469-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "物理网络",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66946f-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "带外管理网络",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669463-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " 基础网络",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6694d3-750c-11ec-9b61-52549e8e7436",
                      "question": " QingCloud云平台在部署青云软件包之前，会在服务器上进行正式安装前的准备工作，具体包括下 面的哪几个阶段。",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "ABCD",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6694db-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " Network",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6694e0-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " Disk",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6694d6-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " OS",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6694e5-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "Post",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6695c9-750c-11ec-9b61-52549e8e7436",
                      "question": " 目前为止QingCloud云平台支持vg方案包含以下哪几种。",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "ABC",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6695d1-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " H3C6800VG",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6695cc-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " X86 VG",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6695ce-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " novg",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6695d3-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " Firewall VG",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6695b7-750c-11ec-9b61-52549e8e7436",
                      "question": " QingCloud云平台虚拟机可以加入哪些类型的网络。",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "ABC",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6695bc-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "自管私有网络。",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6695bf-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "受管私有网络。",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6695c2-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " 混合网络。",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6695b9-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "基础网络。",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6695a2-750c-11ec-9b61-52549e8e7436",
                      "question": " 以下关于QingCloud云平台规划方法错误的选项是哪些。",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "ABC",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6695a8-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " sds1.0计算节点可以大于3的奇数。",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6695ad-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " sds2.0计算节点可以是大于3的奇数。",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6695a4-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "zookpeeper可以规划四个。",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6695aa-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " 管理网络与基础网络可以属于同一个网段。",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669509-750c-11ec-9b61-52549e8e7436",
                      "question": " QingCloud云平台中，包含以下哪些角色。",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "ABC",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669510-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " webservice",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669515-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " dns",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66950c-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " vg",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66951a-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " Firewall",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669567-750c-11ec-9b61-52549e8e7436",
                      "question": " 在QingCloud云平台虚拟机中，zoocassa节点通常会部署以下哪几种服务。",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "ABDE",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669568-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "memcached",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669574-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " zookeeper",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669577-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "cassandra",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66957a-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "postgresql",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669570-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "postgresql",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66956c-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " redis",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6694ee-750c-11ec-9b61-52549e8e7436",
                      "question": "分布式系统通常采用zookeeper实现管理分布式服务的协调工作， 以下哪些是合理的zookeeper节 点数量。",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "BD",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6694f6-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "3",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669500-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "5",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6694f1-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "2",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6694fb-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "4",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669480-750c-11ec-9b61-52549e8e7436",
                      "question": "下列关于QingCloud云平台SDS 2.0存储的描述正确的是哪些？",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "CD",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d66948b-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " SDS 2.0 支持普通SAS、SATA，也可以支持SSD Flash磁盘",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669496-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " SDS 2.0 支持跨机房副本",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669485-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "SDS 2.0 副本以hyper为单位",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669491-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " SDS 2.0 支持数据压缩",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669580-750c-11ec-9b61-52549e8e7436",
                      "question": "下列关于QingCloud云平台的说法哪些正确。",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "ABC",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669582-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "vlan模式部署的环境，基础网络网关在交换机上，计算节点上联端口为trunk。",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669587-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "如果是sanc融合方式部署计算节点，禁止使用supervisorctl restart all命令。",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669589-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " 需要去数据库修改某台vm的host_machine可以直接从pgmaster的节点进入数据库操作。",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669584-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " hyper宕机触发灾难迁移后，用户会发现原宕机hyper上运行的虚拟机发生了重启。",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669555-750c-11ec-9b61-52549e8e7436",
                      "question": "在QingCloud云平台中，客户一个配置变更需要修改server.yaml文件，请问后续还需要如下哪些操 作才算完全完成本次变更。",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "AB",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669561-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " root@webservice0:~# supervisorctl status",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669557-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "root@qingcloud-firstbox:/pitrix/upgrade# ./build_global_conf.sh",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66955a-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " root@qingcloud-firstbox:/pitrix/upgrade# ./update.sh all pitrix-global-conf",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66955d-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " root@webservice0:~# /etc/init.d/apache2 restart",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d66953f-750c-11ec-9b61-52549e8e7436",
                      "question": " QingCloud云平台中以下哪些选项属于负载均衡器（Load Balancer）支持监听模式。",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "负载均衡器（Load Balancer） 可以将来自多个公网地址的访问流量分发到多台主机上，并 支持自动检测并隔离不可用的主机，从而提高业务的服务能力和可用性。同时，你还可以随 时通过添加或删减主机来调整你的服务能力，而且这些操作不会影响业务的正常访问。另 外，负载均衡器还支持灵活配置多种转发策略，实现高级的自定义转发控制功能；支持 HTTP/HTTPS/TCP/UDP 四种监听模式，并支持透明代理，可以让后端主机不做任何更改， 直接获取客户端真实 IP。",
                      "classify": "QACP理论考试",
                      "answer": "ABCD",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d66954f-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " udp",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66954a-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " tcp",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669547-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " http",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669541-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " https",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669524-750c-11ec-9b61-52549e8e7436",
                      "question": " 我们常说的云计算，主要包含以下哪三种服务类型。",
                      "title": "多选题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "ABC",
                      "questionType": 2,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669530-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " SaaS",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669535-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " DaaS",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669528-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " IaaS",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66952c-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": " PaaS",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  }
              ]
          },
          {
              "title": "判断题",
              "questionType": 3,
              "questions": [
                  {
                      "id": "8d66963c-750c-11ec-9b61-52549e8e7436",
                      "question": " 在QingCloud云平台中，SDS2.0（hyper-repl）存储架构，存储节点数量必须是偶数。",
                      "title": "判断题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "错误",
                      "questionType": 3,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d66963e-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "正确",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669640-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "错误",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6695e4-750c-11ec-9b61-52549e8e7436",
                      "question": "一个客户在一个城市有两个数据中心，之间用光纤连接，时延小于1.5ms， 希望能搭建一个同城多 活的QingCloud云平台，需要用到 青云的（Region/AZ ）架构.",
                      "title": "判断题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "一个用户在一个城市有2个数据中心，之间用光纤连接，时延小于1.5ms， 希望能搭建一个同 城多活的青云平台，需要用到 青云的（Region/AZ ）架构.",
                      "classify": "QACP理论考试",
                      "answer": "正确",
                      "questionType": 3,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6695e5-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "正确",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6695e9-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "错误",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669625-750c-11ec-9b61-52549e8e7436",
                      "question": " QingStor Neonsan在部署时存储网络可选择TCP和Roce两个网络协议。",
                      "title": "判断题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "正确",
                      "questionType": 3,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669628-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "正确",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66962b-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "错误",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6695fa-750c-11ec-9b61-52549e8e7436",
                      "question": " QingCloud云平台中，如果采用SDS1.0 存储架构，计算节点数量必须是偶数。",
                      "title": "判断题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "正确",
                      "questionType": 3,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6695fc-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "正确",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6695ff-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "错误",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d66960f-750c-11ec-9b61-52549e8e7436",
                      "question": ". 部署QingStor Neonsan，存储网络的网卡跟管理网络一样也需要做bond。",
                      "title": "判断题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "错误",
                      "questionType": 3,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669612-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "正确",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669614-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "错误",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669631-750c-11ec-9b61-52549e8e7436",
                      "question": " QingStor Neonsan只能和QingCloud云平台对接使用，不能提供给云外物理服务器使用。",
                      "title": "判断题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "错误",
                      "questionType": 3,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669632-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "正确",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669635-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "错误",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d66961a-750c-11ec-9b61-52549e8e7436",
                      "question": "通过QingCloud提供的ISO文件安装操作系统，如果需要自动化安装操作系统，需要将物理机BIOS 模式设置成Legacy。",
                      "title": "判断题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "正确",
                      "questionType": 3,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d66961c-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "正确",
                              "tag": 1,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d66961f-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "错误",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669605-750c-11ec-9b61-52549e8e7436",
                      "question": " 计算节点磁盘为ssd和sata混插配置，存储架构使用SDS1.0、SDS2.0、NeonSAN都可以。  正确",
                      "title": "判断题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "错误",
                      "questionType": 3,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669606-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "正确",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669609-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "错误",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d6695ef-750c-11ec-9b61-52549e8e7436",
                      "question": " QingCloud云平台虚拟机中，CPU、内存、磁盘超卖比越高越好，以使服务器资源利用率最大化。",
                      "title": "判断题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "错误",
                      "questionType": 3,
                      "grade": 1,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d6695f1-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "正确",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d6695f3-750c-11ec-9b61-52549e8e7436",
                              "index": 0,
                              "option": "错误",
                              "tag": 1,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  }
              ]
          },
          {
              "title": "填空题",
              "questionType": 4,
              "questions": [
                  {
                      "id": "8d669661-750c-11ec-9b61-52549e8e7436",
                      "question": "在QingCloud云平台环境中，备份任务通过（）节点和（）节点来完成。",
                      "title": "填空题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "",
                      "questionType": 4,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669663-750c-11ec-9b61-52549e8e7436",
                              "index": 1,
                              "option": "VBR",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669665-750c-11ec-9b61-52549e8e7436",
                              "index": 2,
                              "option": "Snapshot",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669651-750c-11ec-9b61-52549e8e7436",
                      "question": " 可以通过命令（）查看QingCloud云平台服务状态。",
                      "title": "填空题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "",
                      "questionType": 4,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669653-750c-11ec-9b61-52549e8e7436",
                              "index": 1,
                              "option": "supervisorctl status",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d66966c-750c-11ec-9b61-52549e8e7436",
                      "question": "在QingCloud云平台中，安置策略组功能包含两个安置组关系分别是（）（）。",
                      "title": "填空题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "分散：安置策略组内的主机趋向于部署/迁移到不同的物理节点上 \n集中：安置策略组内的主机趋向于部署/迁移到相同的物理节点上",
                      "classify": "QACP理论考试",
                      "answer": "",
                      "questionType": 4,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d66966e-750c-11ec-9b61-52549e8e7436",
                              "index": 1,
                              "option": "分散",
                              "tag": 0,
                              "blankAnswer": ""
                          },
                          {
                              "id": "8d669673-750c-11ec-9b61-52549e8e7436",
                              "index": 2,
                              "option": "集中",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669646-750c-11ec-9b61-52549e8e7436",
                      "question": " 在QingCloud云平台，存储类型为SDS1.0 ，在系统中通过（）命令查看存储状态。",
                      "title": "填空题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "",
                      "questionType": 4,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d669648-750c-11ec-9b61-52549e8e7436",
                              "index": 1,
                              "option": "drbd-overview",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669659-750c-11ec-9b61-52549e8e7436",
                      "question": "当QingCloud云平台采用存储混插模式部署时， 是采用Intel icas软件作为缓冲管理， 请问用（） 命令可以查看icas的缓冲区运行情况？ ",
                      "title": "填空题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "root@bjedu1ar01n04:~# casadm -P -i 1\nWARNING: Intel(R) CAS is running on a non-validated OS!\nCache Id 1\nCache Size 771959222 [4KiB Blocks] / 2944.79 [GiB]\nCache Device /dev/nvme0n1\nCore Devices 2\nInactive Core Devices 0\nWrite Policy wb\nEviction Policy lru\nCleaning Policy acp\nCache line size 4 [KiB]\nMetadata Memory Footprint 38.9 [GiB]\nDirty for 0 [s] / Cache clean\nMetadata Mode normal\nStatus Running\n",
                      "classify": "QACP理论考试",
                      "answer": "",
                      "questionType": 4,
                      "grade": 2,
                      "myGrade": 0,
                      "options": [
                          {
                              "id": "8d66965a-750c-11ec-9b61-52549e8e7436",
                              "index": 1,
                              "option": "casadm -P -i 1",
                              "tag": 0,
                              "blankAnswer": ""
                          }
                      ],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  }
              ]
          },
          {
              "title": "问答题",
              "questionType": 5,
              "questions": [
                  {
                      "id": "8d66968c-750c-11ec-9b61-52549e8e7436",
                      "question": "客户新上一套QingCloud云平台4台管理节点， 10台计算存储节点，计划采用VLAN模式， SDS 1.0（混插）架构。 计算存储节点的服务器配置都是 2 个Intel 4114 CPU (每CPU 10 core，每core 2线程）, 内存 256G， 硬盘 2x600G SAS,1.92T NVME,12*4T SATA 用户要求vCPU按照1:4超配，内存、磁盘不超配。 建议资源使用上限70%。 请完成容量规划。 （内存暂不考虑qingcloud系统自身占用，不考虑1024差异，要求写出计算过程）",
                      "title": "问答题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "vCPU数 内存大小 磁盘大小 设计最大值 2*10*2*4 10*256 10*10*4/2 建议值",
                      "questionType": 5,
                      "grade": 5,
                      "myGrade": 0,
                      "options": [],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669691-750c-11ec-9b61-52549e8e7436",
                      "question": "在QingCloud云平台，当一台hyper节点发生宕机，假设存储类型sds1.0,请描述后台灾难恢复的大 致过程。",
                      "title": "问答题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "HyperA和HyperB互为 mirror，互相之间进行周期性的健康检测（ping，心跳，磁盘检 查）。假设HyperA故障，当HyperB的检测失败时，会启动确认流程，再次检查hyperA是否 真的故障了，如果判断真的故障了，则上报调度中心，发起暂难迁移指令，与此同时修改 hyperA的状态为故障，hyperB节点标记为待命（待命的目的是这个节点已经是单点了，不 让新创建的资源落在这个节点上，原运行中的资源继续运行。）。在其他hyer上拉起 vm（hyperA上的vm），这些vm通过nbd远程挂载hyperB上的数据文件，并在后台copy数 据到vm本地盘，直到所有数据同步完成，vm断掉nbd并切换到本地数据文件并开始正常提 供服务。",
                      "questionType": 5,
                      "grade": 5,
                      "myGrade": 0,
                      "options": [],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d66967e-750c-11ec-9b61-52549e8e7436",
                      "question": "请分析QingCloud云平台关于以下报警内容的报警含义及处置方法。 [edu2] [bjedu2r07n01] has alerts %7C@@%7C\u003ch3\u003e=== compute_agent.log.wf === \u003c/h3\u003e%7C@@%7C2017-05-26 06:49:42,685 CRITICAL -139654258652928- hyper pair [bjedu2r07n01/bjedu2r08n01] may be broken, please check it ... (/usr/lib/python2.7/threading.py:810)|##|##|0|##|3|0|0|0|0|_| ",
                      "title": "问答题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "报警含义：发生hyper pair中断， 通常是网络中断、或其中一台服务器发生了宕机。 \n处置方法：建议去机房排查网络、硬件，快速修复故障。故障修复后，可以将服务器的状态 \n设置回“可用”",
                      "questionType": 5,
                      "grade": 5,
                      "myGrade": 0,
                      "options": [],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669687-750c-11ec-9b61-52549e8e7436",
                      "question": "请阐述修改QingCloud云平台修改虚拟机支持的最大CPU、内存配置的大致步骤。",
                      "title": "问答题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "修改Server.yaml ， 放开后端限制 登录 firstbox， cd /pitrix/conf/variables/global, vi server.yaml 首先找到 resource_limits: bjedu1a: ------- 这是zone name， 下面会有一段支持最大CPU、内存的 配置，根据需要修改 valid_cpu_cores: '1, 2, 4, 8, 12, 16, 20, 24‘ #后端支持的cpu核数配 置 valid_cpu_memory_pairs: #后端支持某个核数的CPU可以配置的MEM大小。 valid_memory_size: '512, 1024, 2048, 4096, 6144, 8192, 12288, 16384, 24576, 32768, 40960, 49152, 65536‘ #后端支持的MEM大小配置。 重新build 全局配置 包 cd /pitrix/upgrade/ root@firstbox:/pitrix/upgrade# ./build_global_conf.sh 分发 到所有节点 root@firstbox:/pitrix/upgrade# ./update.sh all 'pitrix-global-conf' 修改local_config.yaml, 放开前端限制 (建议修改前备份) 登录webservice0虚 机， cd /pitrix/lib/pitrix-webconsole/mysite, vi local_config.yaml 找到： valid_cpu_cores: [1, 2, 4, 8, 16, 32] # define cpu cores valid_memory_sizes: [1024, 2048, 4096, 6144, 8192, 12288, 16384, 24576, 32768, 65536] # define supported memory sizes： 上面的配置是总的配置， 如果下面有针对不同Class类型主机的配置，将以Class的定义为 准。 class_0：对应的性能主机（sas节点）、class_1对应的是超高性能节点（Flash/SSD节 点） valid_cpu_cores_class_0: [1, 2, 4, 8, 12, 16, 32] valid_memory_sizes_class_0: [1024, 2048, 4096, 6144, 8192, 12288, 16384, 24576, 3276 8, 65536] 根据需要修改以上参数 修改完成后，重启apache. service apache2 restart 以上 步骤在webservice1虚机上执行一遍",
                      "questionType": 5,
                      "grade": 5,
                      "myGrade": 0,
                      "options": [],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669683-750c-11ec-9b61-52549e8e7436",
                      "question": " 请描述什么场景下会需要Region服务及Region 服务包含哪些功能。",
                      "title": "问答题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "需要Region服务的场景：构建同城双活/多活方案时；同城灾备方案时；两地三中心容灾方 案时；简洁高效地互联时 \nRegion包含的功能有：Region 级 VPC；Region 级 Vxnet；\nRegion 级 LB Cluster； Region 级 EIP: 可跨可用区漂移；跨可用区版MySQL Plus/RadonDB/MongoDB",
                      "questionType": 5,
                      "grade": 5,
                      "myGrade": 0,
                      "options": [],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  },
                  {
                      "id": "8d669679-750c-11ec-9b61-52549e8e7436",
                      "question": "请阐述QingCloud云平台全量备份，增量备份，备份链的概念。",
                      "title": "问答题",
                      "level": 2,
                      "flag": 0,
                      "star": 0,
                      "parsing": "",
                      "classify": "QACP理论考试",
                      "answer": "全量备份：对硬盘当前状态的全量拷贝 \n增量备份：对硬盘当前状态的增量拷贝，即只保存相对于上一个备份点的变化量 \n备份链：备份链包括一个全量备份点和多个增量备份点。每次做全量备份都会产生一个新的 备份链。",
                      "questionType": 5,
                      "grade": 5,
                      "myGrade": 0,
                      "options": [],
                      "myAnswer": "",
                      "isCorrect": 0,
                      "judgeUserID": "",
                      "judgeGrade": 0,
                      "judgeTime": 0
                  }
              ]
          }
      ]
  }
}

function OnlineTest() {
  const [testInfo, setTestInfo] = useState({
    name: '',
    id: '',
    username: '',
    isPass: 0
  });
  const [initList, setInitList] = useState<QuestionListItem[]>([]);
  const [questionList, setQuestionList] = useState<QuestionListItem[]>([]);
  const [isSpinning, setIsSpinning] = useState(false);
  const urlParams: { id: string, type: LookStatus } = useParams();
  const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify({})) || {};

  useEffect(() => {
    setIsSpinning(true);
    if (urlParams.type === lookStatus.see) {
      previewExamTemp({ id: urlParams.id }).then((res: any) => {
        setIsSpinning(false);
        if (res && res.code === 0) {
          const { paper, name } = res.data;
          setTestInfo({ ...testInfo, name });
          setInitList(paper);
          setQuestionList(paper);
        } else {
          res && message.error(res.msg || '获取失败！');
        }
      })
    }
    if ([lookStatus.view, lookStatus.review].includes(urlParams.type)) {
      getExamRecord({ id: urlParams.id }).then((res: any) => {
        setIsSpinning(false);
      
        if (res && res.code === 0) {
          const { question, examName, examID, userID, isPass } = res.data;
          getUserInfo({ id: userID }).then((resp: any) => {
            if (resp && resp.code === 0) {
              const { user } = resp.data;
              setTestInfo({
                name: examName,
                username: user && user[0] && user[0].userName || "",
                isPass,
                id: examID
              })
            } else {
              resp && message.error(resp.msg || '获取信息出错！');
            }
          })
          setInitList(question);
          setQuestionList(question);
        } else {
          res && message.error(res.msg || '获取失败！');
        }
      })
    }

  }, [urlParams.id]);

  return (
    <Spin tip="加载中..." spinning={false}>
      <div className="manmade-exam">
        <div className="manmade-exam-head">
          <div className="head">
            <div className="head-left">{testInfo.name}</div>
            <div className="head-right">{userinfo.employee_name}</div>
          </div>
        </div>
        <div className="manmade-exam-content">
          <div className="content">
            <AnswerList questionList={data.data.question as any} />
            <QuestionList testInfo={testInfo} questionList={data.data.question as any} setQuestionList={setQuestionList} />
            <ProcessInfo testInfo={testInfo} initList={initList} questionList={data.data.question as any} status={'review'} setQuestionList={setQuestionList} />
          </div>
        </div>
      </div>
    </Spin>
  )
}

export default OnlineTest;
